import {apiClient} from 'core/apiClient';

import {
    CodeValidationParams,
    CodeValidationResponse,
    DashboardDateType,
    ProductDefectRecord,
    ProductDynamicResponse,
    ProductStatusRecord,
    ProductTopRecord,
} from '../types';
import {PackageTypes} from '../types/gtins';

export async function fetchProductDynamicStatistics(
    from: Date,
    to: Date,
    dateType: DashboardDateType,
    packagingType: PackageTypes,
): Promise<ProductDynamicResponse> {
    return apiClient
        .post('/service/chart/dynamic', {from, to, type: dateType, packagingType})
        .then((response) => response.data);
}

export async function fetchProductStatusStatistics(
    from: Date,
    to: Date,
    dateType: DashboardDateType,
    packagingType: PackageTypes,
): Promise<ProductStatusRecord[]> {
    return apiClient
        .post('/service/chart/product-statuses', {from, to, type: dateType, packagingType})
        .then((response) => response.data?.data);
}

export async function fetchProductTopStatistics(
    from: Date,
    to: Date,
    dateType: DashboardDateType,
    packagingType: PackageTypes,
): Promise<ProductTopRecord[]> {
    return apiClient
        .post('/service/chart/product-top', {from, to, type: dateType, packagingType})
        .then((response) => response.data?.data);
}

export async function fetchProductDefectStatistics(
    from: Date,
    to: Date,
    dateType: DashboardDateType,
    packagingType: PackageTypes,
): Promise<ProductDefectRecord[]> {
    return apiClient
        .post('/service/chart/dropout', {from, to, type: dateType, packagingType})
        .then((response) => response.data?.data);
}

export async function validateCode(
    params: CodeValidationParams | null,
): Promise<CodeValidationResponse | null> {
    if (!params) return Promise.resolve(null);
    const formData = new FormData();
    formData.set('sample', params.sample);

    return apiClient
        .post('/validation/photos', formData, {headers: {'Content-Type': 'multipart/form-data'}})
        .then((response) => response.data);
}
